import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { NotificationKind } from '@enmon/commons/lib/enmon';
import type { INotificationsApiClient } from './types/interface';
import type {
  GetNotificationArg,
  GetNotificationsArg,
  MarkNotificationSeenArg,
  UpdateNotificationStatusArg,
} from './types/args';
import type { GetNotificationResult, GetNotificationsResult } from './types/results';
import type { Results } from '.';

export class NotificationsApiClient extends BaseApiClient implements INotificationsApiClient {
  constructor() {
    super('api/notifications');
  }

  public get<T extends NotificationKind | null | undefined = NotificationKind>(
    kind: T,
    filter: GetNotificationsArg,
    signal: RequestOptions['signal'],
  ): Promise<GetNotificationsResult<T>> {
    return this.http.get('', { query: getQuery({ ...filter, kind }), signal });
  }

  public getOne({ id }: GetNotificationArg, signal: RequestOptions['signal']): Promise<GetNotificationResult> {
    return this.http.get(id, { signal });
  }

  public getUnreadSummary(signal: RequestOptions['signal']): Promise<Results.GetNotificationUnreadSummaryResult> {
    return this.http.get('unread', { signal });
  }

  public updateStatus({ id, status }: UpdateNotificationStatusArg): Promise<Results.UpdateNotificationStatusResult> {
    return this.http.patch(`${id}/status`, { status });
  }

  public markSeen({ id }: MarkNotificationSeenArg): Promise<Results.MarkNotificationSeenResult> {
    return this.http.patch(`${id}/seen`, {});
  }
}
